export default {"src":"/login-app/[GIT_HASH]/_next/static/media/radio_empty.0bf65cc9.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};